"use client";
import { ThemeItem } from "@/app/actions/get-problems";
import { cn } from "@/lib/utils";
import { Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { Problem } from "./problem";
interface ProblemCarouselProps {
  theme?: ThemeItem | null;
  pos: number;
}

export function ProblemCarousel({ theme, pos }: ProblemCarouselProps) {
  const isEven = pos % 2 === 0;

  return (
    <div
      className={cn("py-4 xl:py-8 xl:px-8 border-t-2", {
        "bg-[#DED7CA60]": isEven,
      })}
      id={`tema${theme?.id}`}
    >
      <div className="flex flex-col justify-center gap-4 m-auto px-4 container">
        <h4 className="py-2 font-bold text-secondary text-sm xl:text-xl">
          Vote nos problemas sobre {theme?.nome}
        </h4>

        <div className="relative">
          <Swiper
            modules={[Pagination]}
            navigation
            pagination={{ clickable: true }}
            spaceBetween={8}
            breakpoints={{
              480: { slidesPerView: 1.1 },
              640: { slidesPerView: 2.1 },
              768: { slidesPerView: 2.1 },
              1024: { slidesPerView: 3.1 },
              1280: { slidesPerView: 4.1 },
            }}
            className="!pb-12"
          >
            {theme?.problemas.map((item) => (
              <SwiperSlide key={item.id}>
                <Problem {...item} tema={theme?.nome} />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </div>
  );
}
